/*
 * Copyright © 2018 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */

import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
} from '@angular/material/dialog';
import Dexie, {DexieError} from 'dexie';
import {CdkScrollable} from '@angular/cdk/scrolling';
import {MatButton} from '@angular/material/button';

@Component({
    selector: 'elohn-dexie-error',
    templateUrl: './dexie-error.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class DexieErrorComponent {

    public data = inject<{
    dexieError: DexieError;
}>(MAT_DIALOG_DATA);

    public hasQuotaExceeded = false;

    constructor() {
        const error = this.data.dexieError;

        this.hasQuotaExceeded = this.hasError(error, Dexie.errnames.QuotaExceeded);
    }

    private hasError(error: DexieError, name: string): boolean {
        if (error.name === name) {
            return true;
        }

        if (error.inner) {
            return this.hasError(error.inner, name);
        }

        return false;
    }
}
